import { render, staticRenderFns } from "./CollectionFilterControlTypeEmail.vue?vue&type=template&id=11fcd3e1"
import script from "./CollectionFilterControlTypeEmail.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionFilterControlTypeEmail.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports